module.exports = __webpack_public_path__ + "img/Transaction trigger tool.3387c491.jpg";